import {Component, Input, ViewEncapsulation} from '@angular/core';
import {ReportTableRowParametersFiltersStore} from './report-table-row-parameters-filters.store';
import {Observable} from 'rxjs';
import {AdRParamsDimensionFilters} from '../../../../../../shared/interfaces/ad-reports';
import {DimensionComponentObject} from '../../../../../../shared/classes/dimension-component-object';

@Component({
  selector: 'app-report-table-row-parameters-filters',
  templateUrl: './report-table-row-parameters-filters.component.html',
  styleUrls: ['./report-table-row-parameters-filters.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [ReportTableRowParametersFiltersStore]
})
export class ReportTableRowParametersFiltersComponent {
  @Input('parameter') public set parameter(filters: AdRParamsDimensionFilters | null | undefined) {
    if (filters) {
      this._reportTableRowParametersFiltersStore.init(filters);
    }
  };

  public readonly nbFilters$: Observable<number> = this._reportTableRowParametersFiltersStore.nbFilters$;
  public readonly enable$: Observable<boolean> = this._reportTableRowParametersFiltersStore.enable$;
  public readonly filters$: Observable<Array<{ dimension: DimensionComponentObject, values: string }>> = this._reportTableRowParametersFiltersStore.filters$;

  constructor(
    private readonly _reportTableRowParametersFiltersStore: ReportTableRowParametersFiltersStore
  ) {}
}
